/**
 * Adds the stats tracker param (see features/trackers/stats-tracker-context) to a
 * stats request's params. Voluum, Binom and requests outside the stats page get
 * the SAME params object back — same request, same query key as before.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useStatsTrackerParams } from '@/features/trackers/stats-tracker-context';

export function useWithStatsTracker<T extends Record<string, string | number>>(params: T): T {
  const tracker = useStatsTrackerParams();
  return Object.keys(tracker).length > 0 ? { ...params, ...tracker } : params;
}
